import * as React from "react";
import {CommonHelpers} from "@falcon/services";

export class SportsVoucherBanner extends React.Component {


    public render() {

        const sportsVoucherBannerEnabled: boolean = process.env.REACT_APP_SPORTS_VOUCHER_ENABLED ? JSON.parse(process.env.REACT_APP_SPORTS_VOUCHER_ENABLED) : false;
        const showDate = process.env.REACT_APP_SPORTS_VOUCHER_SHOW_DATE;
        const hideDate = process.env.REACT_APP_SPORTS_VOUCHER_HIDE_DATE;

        const sportsVoucherFromDate = CommonHelpers.getDate(showDate);
        const sportsVoucherToDate = CommonHelpers.getDate(hideDate);
        const today = new Date();


        const showVoucherBanner = (showDate === undefined || hideDate === undefined) ? false :
            (sportsVoucherBannerEnabled && today >= sportsVoucherFromDate && today <= sportsVoucherToDate);

        return (
            showVoucherBanner ? <div className="banner">
                <div className="banner-content">
                    <div className="banner-text">
                        To say thanks for being an Allianz customer, we're giving you a free 3-month SportsPass to
                        celebrate the summer of sport. T&Cs apply{'. '}
                        <a href="https://www.allianz-sportspass.co.uk/">Claim your pass</a>
                    </div>
                </div>
            </div> : <></>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/banners/SportsVoucherBanner.tsx